import axios from 'axios';
import {Link} from 'react-router-dom';

const MenuItem = ({label, to = '/'}) => {
    return (
        <Link to={to}>
            <div style={{color: 'black', height: 50, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', borderRadius: 8, outline: '1px solid #aaa', cursor: 'pointer'}}>
                {label}
            </div>
        </Link>
    );
}

export default function Menubar() {
    return (
        <div style={{backgroundColor: '#eee', height: '100%', padding: 10, display: 'flex', flexDirection: 'column', gap: 10}}>
            <Link to='/'>
                <div style={{display: 'flex', gap: 3, alignItems: 'center', color: 'black'}}>
                    <img style={{width: 20, height: 20, filter: 'invert(1)'}} src="/imgs/logo.png" alt="logo" />
                    <h3>행정마당 <span style={{fontWeight: 300}}>| 관리자</span></h3>
                </div>
            </Link>
            <MenuItem label='유저' to='/users' />
            <MenuItem label='제휴신청' to ='/apply' />
            <MenuItem label='견적서' to='/quote' />
            <MenuItem label='댓글' to ='/comments' />
            <MenuItem label='공지사항' to='/notice' />
            <MenuItem label='이벤트' to='/event' />
            <MenuItem label='아이콘' to ='/icon' />
            <MenuItem label='비밀번호 재설정' to ='/resetPassword' />
            {
                sessionStorage.getItem('login') !== 'true' ? null :
                <span onClick={() => {
                    axios.post('/api/manage/logout')
                        .catch((err) => {
                            console.log(err);
                            alert('로그아웃 중 오류가 발생했습니다.');
                        });
                    sessionStorage.clear();
                    window.location.href='/login'
                }}>
                    로그아웃
                </span>
            }
        </div>
    );
}